<template lang="pug">
  .product-review-summary
    .product-review-summary__rating(v-if="loaded")
      star-rating.product-review-summary__stars(:rating="rating")
      a.product-review-summary__count(v-if="count > 0" href="#") {{ reviewMessage }}
      a.product-review-summary__no-ratings(v-else-if="loaded" href="#") No reviews yet!
</template>

<script>
  import axios from 'axios';
  import StarRating from 'scripts/components/basic/StarRating.vue';

  // add client APPKEY here (public facing)
  const YOTPO_APP_KEY = 'oUACzhOLLiqVksjvOHde8kmpSD8Z0mfhT3t60BCz';

  export default {
    name: 'ProductReviewSummary',
    components: { StarRating },
    props: {
      productId: Number,
    },
    data() {
      return {
        loaded: false,
        rating: 0,
        count: 0,
      };
    },
    computed: {
      reviewMessage() {
        return `(${this.count})`;
      },
    },
    created() {
      axios
        .get(`https://api.yotpo.com/products/${YOTPO_APP_KEY}/${this.productId}/bottomline`)
        .then(({ data }) => {
          // endpoint returns => average_score and total_reviews
          const count = data.response.bottomline.total_reviews || 0;

          this.count = count;
          if (count > 0) this.rating = data.response.bottomline.average_score;
        })
        .catch((err) => {
          throw new Error(err.response.data.status.message);
        })
        .finally(() => {
          this.loaded = true;
        });
    },
  };
</script>

<style scoped lang="scss">
  .product-review-summary {
  }

  .product-review-summary__rating {
    display: flex;
    align-items: center;
  }

  .product-review-summary__stars {
    margin-right: 8px;
  }

  .product-review-summary__count,
  .product-review-summary__no-ratings {
    position: relative;
    margin: 0;
    font-size: rem(16);
    line-height: rem(20);
    text-decoration: none;
  }
</style>
